import { FormikConfig, useFormik } from 'formik';

export type InfoOptions<Values> = {
  value?: any;
  parser?: (value: any, values: Values) => any;
};

const useForm = <Values>(props: FormikConfig<Values>) => {
  const form = useFormik<Values>(props);

  const getFieldInfo = (
    field: keyof Values | Omit<string, keyof Values>,
    option: InfoOptions<Values> = {},
  ) => {
    const { parser } = option;
    const { onChange, name, ...rest } = form.getFieldProps(field);
    const touch = form.touched[name];
    const error = form.errors[name];

    const handleChange = (e: any, data: any) => {
      if (parser) {
        return onChange({
          target: { name, value: parser(data.value, form.values) },
        });
      }

      if (Array.isArray(data.options)) {
        return onChange({ target: { name, value: data.value } });
      }

      if (data.countryCode) {
        return onChange({ target: { name, value: e } });
      }

      return onChange(e);
    };

    return {
      name,
      onChange: handleChange,
      error: touch && error,
      id: name,
      ...rest,
      value: option.value || rest.value,
    };
  };

  return { ...form, getFieldInfo };
};

export default useForm;
